'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { addAlert } from 'customer-data-ui-utilities/alerts/Alerts';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_FAILED_MESSAGE_KEY = 'universalSidebar.alertHelpers.addMutationResultAlert.mutationFailed';
const DEFAULT_SUCCEEDED_MESSAGE_KEY = 'universalSidebar.alertHelpers.addMutationResultAlert.mutationSucceeded';
const addMutationResultAlert = ({
  titleText,
  titleKey,
  titleKeyOptions,
  message,
  messageKey,
  messageKeyOptions,
  mutationFailed = false,
  type = mutationFailed ? 'warning' : 'info'
} = {}) => {
  const getMessageKey = () => {
    if (messageKey) return messageKey;
    if (mutationFailed) return DEFAULT_FAILED_MESSAGE_KEY;
    return DEFAULT_SUCCEEDED_MESSAGE_KEY;
  };
  addAlert({
    titleText: titleText || titleKey && /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey,
      options: titleKeyOptions
    }),
    message: message || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: getMessageKey(),
      options: messageKeyOptions
    }),
    type,
    timeout: 7000
  });
};
export default addMutationResultAlert;